<template>
  <MdModal 
    v-if="triggerModal" 
    :class="$style.createEditModal" 
    :id="modalId || 'create-project-modal'" 
    arialabelledby="modal-title" 
    ariadescribedby="modal-description" 
    showoverlay="true" 
    bordered="true" 
    width="480px" 
    :isopen="triggerModal" 
    showclosebutton="true" 
    disablefocustrap="true" 
    closeonescapekey="true" 
    enablebackdropclick="false" 
    isfullpage="false" 
    transition="none" 
    @handleclose="closeModal"
  >
    <div slot="header" :class="$style.modalHeader">
      <MdTypography tag="h5" textalign="start" color="spirits--900" variant="heading5--medium" id="modal-title">
        {{ isEditing ? editHeaderText : headerText }}
      </MdTypography>
    </div>
    <div slot="body" :class="$style.modalBody">
      <!-- Project Type Dropdown -->
      <FouDropdown
        v-if="showProjectType"
        :options="projectTypeOptions"
        :default-value="projectType"
        :selectAction="handleProjectTypeSelectAction"
        :placeholder="projectTypePlaceholder"
        name="project type"
        :genericName="projectTypePlaceholder"
        :error-class="$style.errorClass"
        :isDisabled="isProjectTypeDisabled"
      />
      
      <!-- Project Name Field -->
      <div :class="$style.inputField">       
        <TextField
          name="project name"
          id="project name"
          v-model="projectName"
          :rules="projectNameValidationRule"
          :input-class="[$style.projectNameField, smallPlaceholderPN ? $style.activeProjectInputClass : '']"
          :maxLength="projectNameMaxLength"
          :modelValue="projectName"
          :focus="onFocusPN"
          :keyUp="onChangePN"
          @blur="onBlurPN"
          :showCounter="true"
          :error-class="$style.errorClass"
          :showErrorMessage="!showExistingNameError || ((projectType === 'non-custom-fonts' || projectType === 'FlipFont') && !additionalFieldValue)"
          :placeholderText="projectNamePlaceholder"
          :showPlaceholder="true"
        />
      </div>

      <!-- Additional Field (MID/Order Number for IH, could be different for dropship) -->
      <div v-if="showAdditionalField" :class="$style.inputField">
        <TextField
          :name="additionalFieldName"
          :id="additionalFieldName"
          :rules="midValidationRule"
          :input-class="[smallPlaceholderAF ? $style.activeOrderInputClass : '', $style.projectNameField]"
          v-model="additionalFieldValue"
          :modelValue="additionalFieldValue"
          :focus="onFocusAF"
          @blur="onBlurAF"
          :maxLength="additionalFieldMaxLength"
          :error-class="$style.errorClass"
          :showOptionalText="showAdditionalField"
          :optionalText = "(projectType == 'non-custom-fonts') ? additionalFieldOptionalText : ''"
          :placeholderText="additionalFieldPlaceholder"
          :showPlaceholder="true"
          :showFirstOptionalText="!smallPlaceholderAF ? false : true"
          :firstOptionalText="additionalFieldLabel"
        />
      </div>
      
      <!-- Target Foundry Dropdown -->
      <div :class="[$style.targetFoundryDropdownDiv, checkForError ? $style.changeHeightClass : '']">
        <FouDropdown
          :options="computedFoundryOptions"
          :default-value="computedFoundryValue"
          :placeholder="foundryPlaceholder"
          :smallPlaceHolder="foundryNameLabel"
          :class="$style.orderNumberDropdown"
          :selectAction="handleFoundrySelectAction"
          name="a target foundry"
          :error-class="$style.errorClass"
          @check-for-error="updateCheckForError"
          :isDisabled="isFoundryDisabled || projectType === customType"
          :searchAction="handleSearchAction"
          :isOptionLoading="isOptionLoading"
        />
      </div>
    </div>
    <div slot="footer" :class="$style.modalFooter">
      <MdButton 
        slot="footer" 
        disabled="false" 
        isfullwidth="false" 
        size="large" 
        textalign="center" 
        color="lightgrey" 
        type="button" 
        tabidx="2" 
        variant="none" 
        @click="closeModal"
      >
        {{ cancelText }}
      </MdButton>
      <MdButton 
        slot="footer" 
        :disabled="!isFormValid" 
        isfullwidth="false" 
        size="large" 
        textalign="center" 
        color="blue" 
        tabidx="2" 
        variant="none" 
        @click="proceedCreation"
      >
        <MdIconLoader v-if="proceedBtnLoader" slot="icon-start" animation="spin-right" duration=".7s"></MdIconLoader>
        {{ proceedText }}
      </MdButton>
    </div>
  </MdModal>
</template> 